import IRaiseWorkOrderDetails from "interfaces/IRaiseWorkOrderDetails";
import { GlobalState } from "little-state-machine";

export const updateRaiseWorkOrderDetails = (
  state: GlobalState,
  raiseWorkOrderDetails: IRaiseWorkOrderDetails
) => ({
  ...state,
  raiseWorkOrderDetails
});
